import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  IconButton,
  Tooltip,
} from "@mui/material";
import "./modal-table.scss";
import { formatDate } from "../../../utils/utils";

interface CampaignOwner {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
}

interface Campaign {
  id: number;
  name: string;
  type: string;
  status: string;
  start_date: string;
  end_date: string;
  campaignOwner?: CampaignOwner;
  expected_revenue?: string;
  budgeted_cost?: string;
  membership_status?: string;
  campaign_lead_association_id?: any;
}

interface CampaignTableProps {
  data: any[];
  selectedLeadCaptureForm?: {
    id: number;
    formName: string;
    formLink: string;
  } | null;
  setSelectedLeadCaptureForm?: any;
  multiple?: boolean;
  viewCampaign?: boolean;
  onDelete?: (campaignId: number, campaignLeadAssociationId: number) => void;
  onEditStatus?: (campaign: Campaign) => void;
  noDataMessage?: string;
  isCustomer?: boolean;
  isTaskActionDisabled?: boolean;
}

const LeadCaptureTable: React.FC<CampaignTableProps> = ({
  data,
  selectedLeadCaptureForm,
  setSelectedLeadCaptureForm,
  multiple,
  onEditStatus,
  noDataMessage,
}) => {
  useEffect(() => {
    console.log("Selected Lead Capture Form:", selectedLeadCaptureForm);
  }, [selectedLeadCaptureForm]);

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const fullName =
      firstName && lastName
        ? `${firstName} ${lastName}`
        : firstName
          ? firstName
          : lastName
            ? lastName
            : "-";
    return fullName;
  };
  return (
    <>
      <TableContainer className="campaign-modal__table-container" style={{ maxHeight: "380px" }}>
        <Table
          className={`campaigns-table ${!data.length ? "no-table-border" : ""}`}
        >
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Form Name</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Created On</TableCell>
              <TableCell>Last Submission</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data && data.length > 0 ? (
              (data || []).map((item, index) => (
                <TableRow key={item.id}>
                  <TableCell>
                    <FormControl>
                      <RadioGroup
                        name="campaign-selection"
                        value={selectedLeadCaptureForm?.id?.toString() || ""}
                        onChange={(_, value) => {
                        //   if (
                        //     selectedLeadCaptureForm?.id?.toString() === value
                        //   ) {
                        //     // Unselect if the same radio is clicked
                        //     console.log("Unselecting form");
                        //     setSelectedLeadCaptureForm?.(null);
                        //   }
                          
                            setSelectedLeadCaptureForm?.({
                              id: item.id,
                              formName: item.form_title,
                              formLink: item.form_link,
                            });
                          
                        }}
                      >
                        <FormControlLabel
                          value={item.id.toString()}
                          control={
                            <Radio
                              onClick={() => {
                                if (selectedLeadCaptureForm?.id === item.id) {
                                  setSelectedLeadCaptureForm?.(null);
                                }
                              }}
                            />
                          }
                          label=""
                        />
                      </RadioGroup>
                    </FormControl>
                  </TableCell>
                  <TableCell>{item?.form_title}</TableCell>
                  <TableCell>{fetchFullName(item.createdBy)}</TableCell>
                  <TableCell>{formatDate(item.created_at)}</TableCell>
                  <TableCell>{formatDate(item.submission_date)}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow className="no-border-row">
                <TableCell colSpan={7} align="center">
                  {noDataMessage || "No lead capture forms found."}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default LeadCaptureTable;
